/**
 * Northern Shopper — Landed Pricing Engine
 * window.NorthernShopper.Community + window.NorthernShopper.Pricing
 */
(function () {
	"use strict";

	var NS = (window.NorthernShopper = window.NorthernShopper || {});

	var STORAGE = {
		community: "northerShopperCommunity",
		freightType: "northerShopperFreightType",
		sealiftVoyageId: "northerShopperSealiftVoyageId",
		showLanded: "northernShopperShowLanded",
		b2bLandedDefaulted: "northernShopperB2BLandedDefaulted",
	};

	function isB2BCustomer() {
		return !!(NS.b2b || NS.commercialEnabled);
	}

	function resolveShowLanded() {
		var stored;
		try {
			stored = localStorage.getItem(STORAGE.showLanded);
			if (isB2BCustomer() && localStorage.getItem(STORAGE.b2bLandedDefaulted) !== "true") {
				localStorage.setItem(STORAGE.b2bLandedDefaulted, "true");
				localStorage.setItem(STORAGE.showLanded, "true");
				return true;
			}
		} catch (e) {
			return true;
		}
		return stored !== "false";
	}

	NS.fetch = {
		cartUpdate: function (body) {
			var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
			return fetch(root + "cart/update.js", {
				method: "POST",
				credentials: "same-origin",
				headers: { "Content-Type": "application/json", Accept: "application/json" },
				body: JSON.stringify(body),
			}).then(function (r) {
				return r.text().then(function (text) {
					if (!r.ok || !text) throw new Error("Cart update failed");
					try {
						return JSON.parse(text);
					} catch (e) {
						throw new Error("Cart update failed");
					}
				});
			});
		},
	};

	function decodePayload(el) {
		var raw = el.getAttribute("data-ns-price");
		if (!raw) return null;
		try {
			return JSON.parse(atob(raw));
		} catch (e) {
			return null;
		}
	}

	function getCartEventKey() {
		return (NS.CardQty && NS.CardQty.CART_EVENT_KEY) || "northernShopperCartEvent";
	}

	function broadcastCartEvent() {
		if (NS.CardQty && typeof NS.CardQty.broadcastCartEvent === "function") {
			NS.CardQty.broadcastCartEvent();
			return;
		}
		try {
			localStorage.setItem(getCartEventKey(), String(Date.now()));
		} catch (e) {
			/* ignore */
		}
	}

	function forEachPriceEl(callback) {
		document.querySelectorAll("[data-ns-price]").forEach(callback);
		document.querySelectorAll("template").forEach(function (tpl) {
			if (!tpl.content) return;
			tpl.content.querySelectorAll("[data-ns-price]").forEach(callback);
		});
	}

	function getPaintContext() {
		var communityKey = NS.Community.communityKey;
		var freightType = NS.Community.freightType;
		var rateContext = getRateContext(communityKey, freightType);
		if (!rateContext) return null;
		return {
			rateContext: rateContext,
			freightType: freightType,
			showLanded: NS.showLanded !== false,
		};
	}

	function paintPriceElement(el, rateContext, showLanded, freightType) {
		var payload = decodePayload(el);
		if (!payload) return;
		var lineShowLanded = payload.t === "landed" ? true : showLanded;
		var calc = calculateLine(payload, rateContext, lineShowLanded, freightType);
		var cents = getDisplayAmount(calc, payload, lineShowLanded);
		setPriceElement(el, cents, calc, payload);
	}

	function applyFromStorage() {
		NS.showLanded = resolveShowLanded();
		if (NS.Community && typeof NS.Community.loadFromStorage === "function") {
			NS.Community.loadFromStorage();
			syncSealiftLandings();
			NS.Community.updateHeaderUI();
		}
		NS.Pricing.recalculateAll();
		NS.Pricing.applyProductVisibility();
		document.dispatchEvent(new CustomEvent("ns:community:changed"));
		document.dispatchEvent(new CustomEvent("ns:landed:changed", { detail: { showLanded: NS.showLanded } }));
	}

	function formatMoney(cents) {
		if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
			return Shopify.formatMoney(cents, NS.moneyFormat || "${{amount}}");
		}
		return "$" + (cents / 100).toFixed(2);
	}

	function roundCents(val) {
		return Math.round(val);
	}

	function getSubsidyRate(rates, level) {
		if (!level || level === 0) return 0;
		var key = "subsidy_level_" + level;
		return parseFloat(rates[key]) || 0;
	}

	function findCommunityKey(nameOrKey) {
		if (!nameOrKey || !NS.communities) return null;
		if (NS.communities[nameOrKey]) return nameOrKey;
		var keys = Object.keys(NS.communities);
		for (var i = 0; i < keys.length; i++) {
			var c = NS.communities[keys[i]];
			if (c.name === nameOrKey) return keys[i];
			var alts = c.alternate_names || [];
			for (var j = 0; j < alts.length; j++) {
				if (alts[j] && alts[j].toLowerCase() === String(nameOrKey).toLowerCase()) return keys[i];
			}
		}
		return null;
	}

	function getDefaultCommunityKey() {
		var allowed = getAllowedCommunityKeys();
		var defaultName = NS.defaultCommunity || "Iqaluit";
		var key = findCommunityKey(defaultName);
		if (key && allowed.indexOf(key) !== -1) return key;
		return allowed[0] || null;
	}

	function getAllowedCommunityKeys() {
		var keys = Object.keys(NS.communities || {});
		var restrictToCommercial = !!(NS.commercialEnabled && NS.commercialCommunities && NS.commercialCommunities.length);
		return keys.filter(function (k) {
			var c = NS.communities[k];
			if (!c) return false;
			if (restrictToCommercial) {
				if (c.commercial === false) return false;
				return commercialEntryMatches(NS.commercialCommunities, c, k);
			}
			return c.commercial !== true;
		});
	}

	function getVoyageLandings(voyageId) {
		if (!NS.sealift || !voyageId) return {};
		for (var i = 0; i < NS.sealift.length; i++) {
			if (String(NS.sealift[i].id) === String(voyageId)) {
				return NS.sealift[i].landings || {};
			}
		}
		return {};
	}

	function syncSealiftLandings() {
		NS.sealiftLandings = getVoyageLandings(NS.Community.sealiftVoyageId);
	}

	function commercialEntryValue(entry) {
		if (entry == null || entry === "") return "";
		if (typeof entry === "object") {
			var internalName = entry.internal_name;
			if (internalName && typeof internalName === "object") internalName = internalName.value;
			var name = entry.name;
			if (name && typeof name === "object") name = name.value;
			return internalName || name || entry.handle || "";
		}
		return String(entry);
	}

	function commercialEntryMatches(entries, community, key) {
		if (!community || !entries) return false;
		for (var i = 0; i < entries.length; i++) {
			var value = commercialEntryValue(entries[i]);
			if (!value) continue;
			if (
				value === key ||
				value === community.internal_name ||
				value === community.name ||
				value === String(community.id || "")
			) {
				return true;
			}
		}
		return false;
	}

	function landingMatchesCommunity(landing, communityKey) {
		if (!landing) return false;
		var community = NS.communities[communityKey];
		if (!community) return false;
		var landingNames = [landing.community, landing.community_internal_name];
		var communityNames = [communityKey, community.name, community.internal_name, community.id == null ? "" : String(community.id)];
		for (var i = 0; i < landingNames.length; i++) {
			if (!landingNames[i]) continue;
			if (communityNames.indexOf(landingNames[i]) !== -1 || communityNames.indexOf(String(landingNames[i])) !== -1) return true;
		}
		return false;
	}

	function getLandingForCommunity(communityKey) {
		if (!NS.sealiftLandings) return null;
		var landings = NS.sealiftLandings;
		var handles = Object.keys(landings);
		for (var i = 0; i < handles.length; i++) {
			var l = landings[handles[i]];
			if (landingMatchesCommunity(l, communityKey)) return l;
		}
		return null;
	}

	function communityHasSealiftLanding(communityKey) {
		if (!NS.sealift || !communityKey) return false;
		for (var i = 0; i < NS.sealift.length; i++) {
			var landings = NS.sealift[i].landings || {};
			var handles = Object.keys(landings);
			for (var j = 0; j < handles.length; j++) {
				if (landingMatchesCommunity(landings[handles[j]], communityKey)) return true;
			}
		}
		return false;
	}

	function getVoyagesForCommunity(communityKey) {
		if (!NS.sealift || !communityKey) return [];
		return NS.sealift.filter(function (voyage) {
			var landings = voyage.landings || {};
			return Object.keys(landings).some(function (handle) {
				return landingMatchesCommunity(landings[handle], communityKey);
			});
		});
	}

	function getRateContext(communityKey, freightType) {
		var community = NS.communities[communityKey];
		if (!community) return null;
		if (freightType === "sealift") {
			var landing = getLandingForCommunity(communityKey);
			if (landing) return landing;
		}
		return community;
	}

	function gramsToKg(grams) {
		return (parseFloat(grams) || 0) / 1000;
	}

	function payloadSubsidyLevel(payload, freightType) {
		return freightType === "sealift" ? payload.ssl || 0 : payload.sl || 0;
	}

	function lineUnitPrice(payload) {
		// Sale (`p`) and compare-at (`ca`) are landed independently. Compare
		// payloads use `ca` as the unit price so tax is based on compare-at,
		// while freight and subsidy still come from the same weights.
		if ((payload.t || "total") === "compare") {
			return payload.ca || 0;
		}
		return payload.p || 0;
	}

	function calculateLine(payload, rateContext, showLanded, freightType) {
		var price = lineUnitPrice(payload);
		var qty = payload.q || 1;
		var taxable = payload.tx === 1 || payload.tx === true;
		var taxRate = parseFloat(rateContext.tax_rate) || 0;
		var baseFreight = parseFloat(rateContext.base_freight) || 0;
		var shippingWeightKg = gramsToKg(payload.shw);
		var subsidyWeightKg = gramsToKg(payload.sw);
		var subsidyLevel = payloadSubsidyLevel(payload, freightType);
		var subsidyRate = getSubsidyRate(rateContext, subsidyLevel);

		var unitTax = taxable ? roundCents(price * taxRate) : 0;
		var unitFreight = roundCents(shippingWeightKg * baseFreight * 100);
		var unitFreightTax = roundCents(unitFreight * taxRate);
		// Subsidy is not rounded per unit. Product/line displays use the unrounded
		// amount so cart totals can sum weights first, then apply the community rate.
		var subsidyTotal = subsidyWeightKg * qty * subsidyRate * 100;
		var unitSubsidy = qty ? subsidyTotal / qty : 0;

		var productTotal = price * qty;
		var taxTotal = unitTax * qty;
		var freightTotal = unitFreight * qty;
		var freightTaxTotal = unitFreightTax * qty;
		var productOnlyTotal = productTotal + taxTotal - subsidyTotal;
		var landedTotal = productOnlyTotal + freightTotal + freightTaxTotal;
		var displayTotal = showLanded ? landedTotal : productTotal;

		return {
			price: price,
			tax: unitTax,
			freight: unitFreight,
			freightTax: unitFreightTax,
			subsidy: unitSubsidy,
			subsidyLevel: subsidyLevel,
			subsidyWeightKg: subsidyWeightKg,
			productOnly: qty ? productOnlyTotal / qty : 0,
			landed: qty ? landedTotal / qty : 0,
			nncKg: subsidyRate,
			qty: qty,
			total: displayTotal,
			landedTotal: landedTotal,
			productOnlyTotal: productOnlyTotal,
			productTotal: productTotal,
			taxTotal: taxTotal,
			freightTotal: freightTotal,
			freightTaxTotal: freightTaxTotal,
			subsidyTotal: subsidyTotal,
		};
	}

	function forEachCartLinePayload(callback) {
		document.querySelectorAll("[data-ns-cart-line]").forEach(function (el) {
			var payload = decodePayload(el);
			if (payload) callback(payload);
		});
	}

	function calculateCartTotals(rateContext, freightType) {
		var taxRate = parseFloat(rateContext.tax_rate) || 0;
		var baseFreight = parseFloat(rateContext.base_freight) || 0;
		var productTotal = 0;
		var taxTotal = 0;
		var shippingGrams = 0;
		var weightGramsByLevel = {};

		forEachCartLinePayload(function (payload) {
			var calc = calculateLine(payload, rateContext, true, freightType);
			productTotal += calc.productTotal;
			taxTotal += calc.taxTotal;

			var shippingLineGrams = (parseFloat(payload.shw) || 0) * (payload.q || 1);
			if (shippingLineGrams > 0) {
				shippingGrams += shippingLineGrams;
			}

			var level = payloadSubsidyLevel(payload, freightType);
			var grams = (parseFloat(payload.sw) || 0) * (payload.q || 1);
			if (level > 0 && grams > 0) {
				weightGramsByLevel[level] = (weightGramsByLevel[level] || 0) + grams;
			}
		});

		var freightTotal = roundCents(gramsToKg(shippingGrams) * baseFreight * 100);
		var freightTaxTotal = roundCents(freightTotal * taxRate);

		var subsidyByLevel = {};
		var subsidyTotal = 0;
		Object.keys(weightGramsByLevel).forEach(function (levelKey) {
			var level = Number(levelKey);
			var rate = getSubsidyRate(rateContext, level);
			var cents = roundCents(gramsToKg(weightGramsByLevel[level]) * rate * 100);
			if (cents !== 0) {
				subsidyByLevel[level] = {
					cents: cents,
					weightKg: gramsToKg(weightGramsByLevel[level]),
					rate: rate,
				};
				subsidyTotal += cents;
			}
		});

		return {
			productTotal: productTotal,
			taxTotal: taxTotal,
			freightTotal: freightTotal,
			freightTaxTotal: freightTaxTotal,
			freightWeightKg: gramsToKg(shippingGrams),
			freightRate: baseFreight,
			subsidyByLevel: subsidyByLevel,
			subsidyTotal: subsidyTotal,
			landedTotal: productTotal + taxTotal + freightTotal + freightTaxTotal - subsidyTotal,
		};
	}

	function getDisplayAmount(calc, payload, showLanded) {
		var t = payload.t || "total";
		switch (t) {
			case "price":
				return calc.price;
			case "tax":
				return calc.taxTotal;
			case "freight_total":
				return calc.freightTotal;
			case "freight_tax":
				return calc.freightTaxTotal;
			case "subsidy":
				return calc.subsidyTotal;
			case "no_subsidy":
				return calc.productOnlyTotal + (showLanded ? calc.freightTotal + calc.freightTaxTotal : 0);
			case "nnc_kg":
				return Math.round(calc.nncKg * 100);
			case "product_only":
				return calc.productOnlyTotal;
			case "product_total":
				return calc.productTotal;
			case "landed":
				return calc.landedTotal;
			case "compare":
			case "total":
			default:
				return showLanded ? calc.landedTotal : calc.productTotal;
		}
	}

	function isMainPricePayload(payload) {
		return (payload.t || "total") === "total";
	}

	function getLandedCostTooltipText(money) {
		var template =
			(window.NorthernShopperStrings && window.NorthernShopperStrings.landedCostTooltip) || "Landed Cost {{ amount }}";
		return template.replace(/\{\{\s*amount\s*\}\}/g, money);
	}

	function setPriceElement(el, cents, calc, payload) {
		var formatted = formatMoney(roundCents(cents));
		var amountEl = el.querySelector("[data-ns-price-amount]");
		var tooltipEl = el.querySelector("[data-ns-landed-tooltip]");
		if (!amountEl) {
			amountEl = document.createElement("span");
			amountEl.setAttribute("data-ns-price-amount", "");
			el.textContent = "";
			el.appendChild(amountEl);
			if (tooltipEl) el.appendChild(tooltipEl);
		}
		amountEl.textContent = formatted;

		if (!isMainPricePayload(payload)) {
			el.removeAttribute("data-tooltip");
			el.removeAttribute("aria-label");
			if (tooltipEl) tooltipEl.remove();
			return;
		}

		if (!tooltipEl) {
			tooltipEl = document.createElement("span");
			tooltipEl.className = "tooltip pointer-events-none";
			tooltipEl.setAttribute("data-ns-landed-tooltip", "");
			el.appendChild(tooltipEl);
		}
		var tooltipText = getLandedCostTooltipText(formatMoney(roundCents(calc.landedTotal)));
		tooltipEl.textContent = tooltipText;
		el.setAttribute("data-tooltip", "");
		el.setAttribute("aria-label", tooltipText);
	}

	function getSubsidyLevelLabel(level) {
		var template =
			(window.NorthernShopperStrings && window.NorthernShopperStrings.subsidyLevelLabel) || "Level {{ level }}";
		return template.replace("{{ level }}", String(level));
	}

	function formatWeightKg(kg) {
		return String(Math.round((parseFloat(kg) || 0) * 1000) / 1000);
	}

	function getWeightRateText(weightKg, ratePerKg) {
		var template =
			(window.NorthernShopperStrings && window.NorthernShopperStrings.breakdownWeightRate) ||
			"{{ weight }} kg @ {{ rate }}/kg";
		return template
			.replace(/\{\{\s*weight\s*\}\}/g, formatWeightKg(weightKg))
			.replace(/\{\{\s*rate\s*\}\}/g, formatMoney(roundCents((parseFloat(ratePerKg) || 0) * 100)));
	}

	function updateCartBreakdown() {
		var roots = document.querySelectorAll(".ns-custom-cost-breakdown--cart");
		var communityKey = NS.Community.communityKey;
		var freightType = NS.Community.freightType;
		var rateContext = getRateContext(communityKey, freightType);
		if (!rateContext) return;

		var showLanded = NS.showLanded !== false;
		var totals = calculateCartTotals(rateContext, freightType);
		var productTotal = totals.productTotal;
		var taxTotal = totals.taxTotal;
		var freightTotal = totals.freightTotal;
		var freightTaxTotal = totals.freightTaxTotal;
		var subsidyByLevel = totals.subsidyByLevel;
		var freightWeightKg = totals.freightWeightKg;
		var freightRate = totals.freightRate;
		var landedTotal = totals.landedTotal;

		var displayTotal = showLanded ? landedTotal : productTotal;

		var setMoney = function (root, selector, cents) {
			var el = root.querySelector(selector);
			if (el) el.textContent = formatMoney(cents);
		};

		var levels = Object.keys(subsidyByLevel)
			.map(Number)
			.sort(function (a, b) {
				return a - b;
			});

		var subsidyHtml;
		if (!levels.length) {
			subsidyHtml =
				'<div class="ns-custom-cost-breakdown__row" data-ns-cart-subsidy-empty>' +
				"<span>" +
				((window.NorthernShopperStrings && window.NorthernShopperStrings.subsidyNone) || "NNC subsidy") +
				"</span>" +
				"<span>" +
				formatMoney(0) +
				"</span></div>";
		} else {
			subsidyHtml = levels
				.map(function (level) {
					return (
						'<div class="ns-custom-cost-breakdown__row">' +
						'<div class="ns-custom-cost-breakdown__label">' +
						"<span>" +
						((window.NorthernShopperStrings && window.NorthernShopperStrings.subsidy) || "NNC subsidy") +
						"</span>" +
						'<span class="ns-custom-cost-breakdown__meta">' +
						getSubsidyLevelLabel(level) +
						" · " +
						getWeightRateText(subsidyByLevel[level].weightKg, subsidyByLevel[level].rate) +
						"</span></div>" +
						'<span class="ns-custom-cost-breakdown__deduction">-' +
						formatMoney(subsidyByLevel[level].cents) +
						"</span></div>"
					);
				})
				.join("");
		}

		roots.forEach(function (root) {
			setMoney(root, "[data-ns-cart-breakdown='product_total']", productTotal);
			setMoney(root, "[data-ns-cart-breakdown='tax']", taxTotal);
			setMoney(root, "[data-ns-cart-breakdown='freight']", freightTotal);
			setMoney(root, "[data-ns-cart-breakdown='freight_tax']", freightTaxTotal);
			setMoney(root, "[data-ns-cart-breakdown='landed_total']", landedTotal);

			var freightMeta = root.querySelector("[data-ns-cart-breakdown='freight_meta']");
			if (freightMeta) {
				freightMeta.textContent = getWeightRateText(freightWeightKg, freightRate);
				freightMeta.hidden = false;
			}

			root.querySelectorAll("[data-ns-cart-freight-row]").forEach(function (row) {
				row.hidden = !showLanded;
			});

			var subsidyRoot = root.querySelector("[data-ns-cart-subsidy-rows]");
			if (subsidyRoot) subsidyRoot.innerHTML = subsidyHtml;
		});

		document.querySelectorAll("[data-ns-cart-landed-total]").forEach(function (el) {
			el.textContent = formatMoney(displayTotal);
		});

		var totalLabel = showLanded
			? (window.NorthernShopperStrings && window.NorthernShopperStrings.landedTotal) || "Landed total"
			: (window.NorthernShopperStrings && window.NorthernShopperStrings.regularPrice) || "Regular price";
		document.querySelectorAll("[data-ns-cart-total-label]").forEach(function (el) {
			el.textContent = totalLabel;
		});

		var shippingAndSubsidy = landedTotal - productTotal;
		var shippingAndSubsidyText =
			shippingAndSubsidy < 0 ? "-" + formatMoney(Math.abs(shippingAndSubsidy)) : formatMoney(shippingAndSubsidy);
		document.querySelectorAll("[data-ns-cart-regular-extras]").forEach(function (root) {
			root.hidden = showLanded;
			var shippingEl = root.querySelector("[data-ns-cart-shipping-subsidy]");
			if (shippingEl) shippingEl.textContent = shippingAndSubsidyText;
			var landedEl = root.querySelector("[data-ns-cart-regular-landed-total]");
			if (landedEl) landedEl.textContent = formatMoney(landedTotal);
		});

		document.querySelectorAll("[data-ns-checkout-warning]").forEach(function (warn) {
			var setWarn = function (key, cents) {
				var el = warn.querySelector("[data-ns-checkout-warn='" + key + "']");
				if (el) el.textContent = formatMoney(cents);
			};
			// Checkout split: product (pre-tax) | product tax (if any) | remainder
			// (freight + freight tax − subsidy). Always sums to landed.
			var checkoutProduct = productTotal;
			var checkoutTax = taxTotal;
			var checkoutShipping = Math.max(0, landedTotal - checkoutProduct - checkoutTax);
			var hasProductTax = checkoutTax > 0;
			setWarn("landed", landedTotal);
			setWarn("product", checkoutProduct);
			setWarn("tax", checkoutTax);
			setWarn("shipping", checkoutShipping);

			var taxRow = warn.querySelector("[data-ns-checkout-warn-tax-row]");
			if (taxRow) taxRow.hidden = !hasProductTax;

			var partsEl = warn.querySelector("[data-ns-checkout-warn-parts]");
			if (partsEl) {
				var parts = hasProductTax
					? partsEl.getAttribute("data-parts-three")
					: partsEl.getAttribute("data-parts-two");
				if (parts) partsEl.textContent = parts;
			}
		});
	}

	NS.Community = {
		communityKey: null,
		freightType: "air",
		sealiftVoyageId: null,

		init: function () {
			this.applyUrlParams();
			this.loadFromStorage();
			if (!this.communityKey) {
				this.communityKey = getDefaultCommunityKey();
			}
			if (!NS.sealift || !NS.sealift.some(function (v) { return String(v.id) === String(this.sealiftVoyageId); }, this)) {
				this.sealiftVoyageId = NS.sealift && NS.sealift.length ? NS.sealift[0].id : null;
				if (this.sealiftVoyageId) localStorage.setItem(STORAGE.sealiftVoyageId, this.sealiftVoyageId);
				else localStorage.removeItem(STORAGE.sealiftVoyageId);
			}
			syncSealiftLandings();
			if (this.freightType === "sealift" && !getLandingForCommunity(this.communityKey)) {
				this.freightType = "air";
				localStorage.setItem(STORAGE.freightType, "air");
			}
			this.syncCartAttributes(false).catch(function () {
				/* crawlers and bot-blocked POSTs should not surface */
			});
			this.updateHeaderUI();
			NS.Pricing.recalculateAll();
			document.dispatchEvent(new CustomEvent("ns:community:ready"));
		},

		applyUrlParams: function () {
			var params = new URLSearchParams(window.location.search);
			var community = params.get("community");
			var freight = params.get("freight_type");
			if (community) {
				var key = findCommunityKey(community);
				if (key) localStorage.setItem(STORAGE.community, key);
			}
			if (freight === "sealift" || freight === "air") {
				localStorage.setItem(STORAGE.freightType, freight);
			}
			if (community || freight) {
				params.delete("community");
				params.delete("freight_type");
				var qs = params.toString();
				var url = window.location.pathname + (qs ? "?" + qs : "") + window.location.hash;
				history.replaceState({}, "", url);
			}
		},

		loadFromStorage: function () {
			var allowed = getAllowedCommunityKeys();
			var stored = localStorage.getItem(STORAGE.community);
			if (stored && allowed.indexOf(stored) !== -1) {
				this.communityKey = stored;
			} else {
				if (stored) localStorage.removeItem(STORAGE.community);
				if (allowed.length) {
					this.communityKey = getDefaultCommunityKey() || allowed[0];
				}
			}
			var storedFreight = localStorage.getItem(STORAGE.freightType);
			this.freightType = storedFreight === "sealift" ? "sealift" : "air";
			this.sealiftVoyageId = localStorage.getItem(STORAGE.sealiftVoyageId) || null;
			if (this.freightType === "sealift" && !getLandingForCommunity(this.communityKey)) {
				this.freightType = "air";
				localStorage.setItem(STORAGE.freightType, "air");
			}
			if (!storedFreight) {
				localStorage.setItem(STORAGE.freightType, "air");
			}
			NS.currentCommunity = this.communityKey ? NS.communities[this.communityKey] : null;
		},

		getCommunity: function () {
			return this.communityKey ? NS.communities[this.communityKey] : null;
		},

		hasSealiftLanding: function () {
			return !!getLandingForCommunity(this.communityKey);
		},

		communityHasSealiftLanding: function (communityKey) {
			return communityHasSealiftLanding(communityKey || this.communityKey);
		},

		getVoyagesForCommunity: function (communityKey) {
			return getVoyagesForCommunity(communityKey || this.communityKey);
		},

		getAllowedKeys: function () {
			return getAllowedCommunityKeys();
		},

		syncSealiftLandings: function () {
			syncSealiftLandings();
		},

		getVoyageLandings: function (voyageId) {
			return getVoyageLandings(voyageId);
		},

		setCommunity: function (key, freightType, voyageId, skipCartCleanup) {
			var allowed = getAllowedCommunityKeys();
			if (allowed.indexOf(key) === -1) return Promise.resolve();
			this.communityKey = key;
			NS.currentCommunity = NS.communities[key];
			localStorage.setItem(STORAGE.community, key);
			if (voyageId !== undefined) {
				this.sealiftVoyageId = voyageId;
				if (voyageId) localStorage.setItem(STORAGE.sealiftVoyageId, voyageId);
				else localStorage.removeItem(STORAGE.sealiftVoyageId);
			}
			syncSealiftLandings();
			if (freightType) {
				if (freightType === "sealift" && !communityHasSealiftLanding(key)) {
					freightType = "air";
				} else if (freightType === "sealift" && !getLandingForCommunity(key)) {
					var voyages = getVoyagesForCommunity(key);
					if (voyages.length) {
						this.sealiftVoyageId = voyages[0].id;
						localStorage.setItem(STORAGE.sealiftVoyageId, this.sealiftVoyageId);
						syncSealiftLandings();
					}
					if (!getLandingForCommunity(key)) {
						freightType = "air";
					}
				}
				this.freightType = freightType;
				localStorage.setItem(STORAGE.freightType, freightType);
			}
			this.updateHeaderUI();
			var self = this;
			var chain = this.syncCartAttributes(false);
			if (!skipCartCleanup && this.freightType === "sealift") {
				chain = chain.then(function () {
					return self.removeNonSealiftItems();
				});
			}
			return chain.then(function () {
				NS.Pricing.recalculateAll();
				NS.Pricing.applyProductVisibility();
				document.dispatchEvent(new CustomEvent("ns:community:changed"));
				broadcastCartEvent();
			});
		},

		removeNonSealiftItems: function () {
			var updates = {};
			var removed = [];
			(NS.cart || []).forEach(function (item, index) {
				if (!item.sealift) {
					updates[item.key] = 0;
					removed.push(item);
				}
			});
			if (!Object.keys(updates).length) return Promise.resolve([]);
			var self = this;
			return fetch("/cart/update.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ updates: updates }),
			})
				.then(function (r) {
					return r.json();
				})
				.then(function (cart) {
					NS.cart = cart.items.map(function (item) {
						return {
							key: item.key,
							variant_id: item.variant_id,
							quantity: item.quantity,
							sealift: item.properties && item.properties._sealift === "true",
						};
					});
					self.showRemovalNotice(removed.length);
					if (window.FoxTheme && FoxTheme.pubsub) {
						FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
					}
					return removed;
				});
		},

		showRemovalNotice: function (count) {
			if (!count) return;
			var el = document.getElementById("ns-sealift-removal-notice");
			if (!el) {
				el = document.createElement("div");
				el.id = "ns-sealift-removal-notice";
				el.className = "ns-custom-notice ns-custom-notice--warning";
				document.body.appendChild(el);
			}
			var prefix = (window.NorthernShopperStrings && window.NorthernShopperStrings.sealiftRemovalPrefix) || "Some items were removed because they are not available via sealift:";
			el.textContent = prefix + " " + count;
			el.hidden = false;
			setTimeout(function () {
				el.hidden = true;
			}, 8000);
		},

		syncCartAttributes: function (recalculate) {
			var community = this.getCommunity();
			var attrs = {
				community_id: community ? String(community.id) : "",
				sealift_voyage_id: this.freightType === "sealift" && this.sealiftVoyageId ? String(this.sealiftVoyageId) : "",
			};
			var current = NS.cartAttributes || {};
			if (
				String(current.community_id || "") === attrs.community_id &&
				String(current.sealift_voyage_id || "") === attrs.sealift_voyage_id
			) {
				if (recalculate !== false) NS.Pricing.recalculateAll();
				return Promise.resolve();
			}
			return NS.fetch.cartUpdate({ attributes: attrs }).then(function () {
				if (!NS.cartAttributes) NS.cartAttributes = {};
				NS.cartAttributes.community_id = attrs.community_id;
				NS.cartAttributes.sealift_voyage_id = attrs.sealift_voyage_id;
				if (recalculate !== false) NS.Pricing.recalculateAll();
			});
		},

		updateHeaderUI: function () {
			var community = this.getCommunity();
			var freightType = this.freightType;
			var nameEls = document.querySelectorAll(".current-community-name, .community-text");
			nameEls.forEach(function (el) {
				el.textContent = community ? community.name : NS.defaultCommunity || "Iqaluit";
			});
			document.querySelectorAll(".ns-custom-freight-icon").forEach(function (iconEl) {
				iconEl.dataset.freight = freightType;
				iconEl.setAttribute("aria-label", freightType === "sealift" ? "Sealift freight" : "Airlift freight");
				iconEl.querySelectorAll("[data-ns-freight-icon]").forEach(function (modeEl) {
					modeEl.hidden = modeEl.getAttribute("data-ns-freight-icon") !== freightType;
				});
			});
			document.body.dataset.nsFreight = freightType;
		},
	};

	NS.Pricing = {
		setShowLanded: function (show) {
			NS.showLanded = show;
			localStorage.setItem(STORAGE.showLanded, show ? "true" : "false");
			this.recalculateAll();
			document.dispatchEvent(new CustomEvent("ns:landed:changed", { detail: { showLanded: show } }));
			broadcastCartEvent();
		},

		updateElement: function (el) {
			var ctx = getPaintContext();
			if (!ctx || !el) return;
			paintPriceElement(el, ctx.rateContext, ctx.showLanded, ctx.freightType);
		},

		recalculateRoot: function (root) {
			var ctx = getPaintContext();
			if (!ctx || !root || !root.querySelectorAll) return;
			root.querySelectorAll("[data-ns-price]").forEach(function (el) {
				paintPriceElement(el, ctx.rateContext, ctx.showLanded, ctx.freightType);
			});
		},

		recalculateAll: function () {
			var ctx = getPaintContext();
			if (!ctx) return;
			forEachPriceEl(function (el) {
				paintPriceElement(el, ctx.rateContext, ctx.showLanded, ctx.freightType);
			});
			updateCartBreakdown();
			this.updateMinimumWarnings();
		},

		updateMinimumWarnings: function () {
			var warningEl = document.getElementById("ns-minimum-order-warning");
			var subtotal = 0;
			var communityKey = NS.Community.communityKey;
			var freightType = NS.Community.freightType;
			var rateContext = getRateContext(communityKey, freightType);
			if (!rateContext) return;
			var lineEls = document.querySelectorAll("[data-ns-cart-line]");
			if (lineEls.length) {
				subtotal = calculateCartTotals(rateContext, freightType).landedTotal;
			} else {
				document.querySelectorAll("[data-ns-price]").forEach(function (el) {
					var payload = decodePayload(el);
					if (!payload || payload.t !== "total") return;
					var calc = calculateLine(payload, rateContext, true, freightType);
					subtotal += calc.landedTotal;
				});
			}
			var minOrder = Math.round((NS.minimumOrderValue || 0) * 100);
			var belowMinimum = minOrder > 0 && subtotal < minOrder;
			if (warningEl) warningEl.hidden = !belowMinimum;
			document.querySelectorAll("[data-ns-checkout-warning]").forEach(function (el) {
				el.hidden = belowMinimum;
			});
			if (typeof NS.setCheckoutBlocked === "function") {
				NS.setCheckoutBlocked(belowMinimum);
			} else {
				document.querySelectorAll("#checkout, button[name='checkout'], [type='submit'][name='checkout']").forEach(function (btn) {
					btn.disabled = belowMinimum;
					btn.setAttribute("aria-disabled", belowMinimum ? "true" : "false");
					btn.classList.toggle("ns-custom-checkout--blocked", belowMinimum);
				});
			}
		},

		applyProductVisibility: function () {
			var freightType = NS.Community.freightType;
			document.querySelectorAll("[data-ns-sealift-eligible]").forEach(function (el) {
				var eligible = el.getAttribute("data-ns-sealift-eligible") === "true";
				if (freightType === "sealift" && !eligible) {
					el.classList.add("ns-custom-unavailable");
				} else {
					el.classList.remove("ns-custom-unavailable");
				}
			});
			document.querySelectorAll("[data-ns-sealift-filter]").forEach(function (el) {
				var eligible = el.getAttribute("data-ns-sealift-filter") === "true";
				if (freightType === "sealift" && !eligible) {
					el.hidden = true;
				} else {
					el.hidden = false;
				}
			});
		},

		// Cart-level Jordan's Principle / ICFI mix restrictions are disabled.
		validateICFI: function () {
			return { valid: true };
		},
	};

	function nodeHasPrice(node) {
		return !!(node.matches && node.matches("[data-ns-price]"));
	}

	function nodeHasSealiftState(node) {
		return !!(
			(node.matches && node.matches("[data-ns-sealift-eligible], [data-ns-sealift-filter]")) ||
			(node.querySelector && node.querySelector("[data-ns-sealift-eligible], [data-ns-sealift-filter]"))
		);
	}

	function paintInsertedNode(node, ctx) {
		var painted = false;
		if (nodeHasPrice(node)) {
			paintPriceElement(node, ctx.rateContext, ctx.showLanded, ctx.freightType);
			painted = true;
		}
		if (!node.querySelectorAll) return painted;
		var prices = node.querySelectorAll("[data-ns-price]");
		if (!prices.length) return painted;
		prices.forEach(function (el) {
			paintPriceElement(el, ctx.rateContext, ctx.showLanded, ctx.freightType);
		});
		return true;
	}

	// Product HTML inserted after init (predictive search, filters, recommendations)
	// still carries the server price. Paint it with the current landed mode.
	function observeInsertedPrices() {
		if (typeof MutationObserver === "undefined" || !document.body) return;
		var observer = new MutationObserver(function (mutations) {
			var ctx = getPaintContext();
			var needsVisibility = false;
			mutations.forEach(function (mutation) {
				mutation.addedNodes.forEach(function (node) {
					if (!node || node.nodeType !== 1) return;
					if (ctx && paintInsertedNode(node, ctx)) needsVisibility = true;
					if (nodeHasSealiftState(node)) needsVisibility = true;
				});
			});
			if (needsVisibility) NS.Pricing.applyProductVisibility();
		});
		observer.observe(document.body, { childList: true, subtree: true });
	}

	function bindThemeEvents() {
		window.addEventListener("storage", function (e) {
			if (e.key === getCartEventKey()) {
				applyFromStorage();
			}
		});
		if (typeof FoxTheme === "undefined" || !FoxTheme.pubsub) return;
		var events = FoxTheme.pubsub.PUB_SUB_EVENTS;
		FoxTheme.pubsub.subscribe(events.cartUpdate, function (event) {
			if (event && event.cart && event.cart.items) {
				NS.cart = event.cart.items.map(function (item) {
					var prev = null;
					var existing = NS.cart || [];
					for (var i = 0; i < existing.length; i++) {
						if (existing[i].key === item.key || existing[i].variant_id === item.variant_id) {
							prev = existing[i];
							break;
						}
					}
					return {
						key: item.key,
						variant_id: item.variant_id,
						quantity: item.quantity,
						sealift: (item.properties && item.properties._sealift === "true") || (prev && prev.sealift),
						icfi_grocery: prev ? prev.icfi_grocery : false,
						icfi_diaper: prev ? prev.icfi_diaper : false,
						commercial_product: prev ? prev.commercial_product : false,
					};
				});
			}
			// Section HTML may swap in another subscriber; defer so new payloads are present.
			requestAnimationFrame(function () {
				NS.Pricing.recalculateAll();
			});
		});
		FoxTheme.pubsub.subscribe(events.variantChange, function () {
			NS.Pricing.recalculateAll();
		});
		FoxTheme.pubsub.subscribe(events.optionValueSelectionChange, function () {
			setTimeout(function () {
				NS.Pricing.recalculateAll();
			}, 100);
		});
	}

	function init() {
		if (!NS.communities || !Object.keys(NS.communities).length) {
			console.warn("[NorthernShopper] No communities configured");
		}
		NS.Community.init();
		NS.Pricing.applyProductVisibility();
		observeInsertedPrices();
		bindThemeEvents();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
